export default __webpack_public_path__ + "static/media/DFPLiHei-Md.e5c8f778.ttf";